import { useProductList } from '@jetshop/core/hooks/ProductList';
import React from 'react';
import { styled } from 'linaria/react';
import FavoriteIcon from '../ui/icons/FavouriteIcon';
import { theme } from '../Theming/Theming';

const FavouriteWrapper = styled('div')`
  z-index: 1;
  bottom: 0;
  right: 0;
  ${theme.above.md} {
    bottom: 0;
  }
  button {
    background: transparent;
    svg {
      font-size: 1.4rem;
      &.active {
        color: ${theme.favourites.colorActive};
      }
      ${theme.above.md} {
        font-size: 1.8rem;
      }
    }
  }
`;

export function Favourite({ product, variant, ...rest }) {
  const articleNumber = product.articleNumber;

  const selectedVariation = product.variant || variant;
  const variantArticleNumber = selectedVariation?.articleNumber;

  const { toggle, inList } = useProductList();

  function toggleWithoutBubble(e) {
    e.preventDefault();
    toggle(articleNumber, {
      variantArticleNumber
    });
  }

  const isInList = inList(articleNumber, {
    variantArticleNumber
  });

  return (
    <FavouriteWrapper {...rest}>
      <button onClick={toggleWithoutBubble}>
        <FavoriteIcon className={isInList ? 'active' : 'inactive'} />
      </button>
    </FavouriteWrapper>
  );
}
